/* BeanBurds RTL helper, 3 Oct 2026. Loaded only on right-to-left pages (Arabic). Three jobs.
   1. Arabic font faces for brand-font weights that sections load on their own (see below).
   2. Carousels written for left to right run right to left (see below).
   3. Bidi guard. Text with no Arabic in it (an English review, a line not translated yet) keeps the page's
   right alignment but reads as its own left-to-right run, so its punctuation sits where English
   puts it: "Is it in stock?" instead of "?Is it in stock". Anything containing Arabic is left
   alone. Runs one task after parse and on content added later; never waits for window.load. */
(function () {
  try {
    var root = document.documentElement;
    if (root.getAttribute('dir') !== 'rtl') return;

    // Arabic faces for brand-font weights a section loads on its own (Instrument Sans 500 from Google Fonts on the
    // equipment, B2B and xBloom pages). Each gets a Plex face with the same weight and style, so the browser merges
    // them: Latin stays on the brand font, Arabic uses Plex. bb-rtl.css already covers the theme's own faces.
    var me = document.currentScript;
    var base = me && me.src ? me.src.split('bb-rtl.js')[0] : '';
    var BRAND = { 'instrument sans': 1, 'inter': 1, 'figtree': 1, 'instrument serif': 1 };
    var URANGE = 'U+0600-06FF, U+0750-077F, U+0870-08FF, U+FB50-FDFF, U+FE70-FEFF, U+200C-200F';
    function plexFor(w) { return w < 450 ? 400 : w < 550 ? 500 : w < 650 ? 600 : 700; }
    function fillFaces() {
      if (!base || !document.fonts || typeof FontFace === 'undefined') return;
      var have = {};
      var want = [];
      document.fonts.forEach(function (f) {
        var fam = String(f.family).replace(/["']/g, '');
        if (!BRAND[fam.toLowerCase()]) return;
        var key = fam.toLowerCase() + '|' + f.weight + '|' + f.style;
        if (String(f.unicodeRange).toUpperCase().indexOf('U+600-6FF') === 0) have[key] = 1;
        else want.push([fam, String(f.weight), f.style, key]);
      });
      for (var i = 0; i < want.length; i++) {
        var w = want[i];
        if (have[w[3]] || w[1].indexOf(' ') > -1) continue;
        have[w[3]] = 1;
        try {
          document.fonts.add(new FontFace(w[0], 'url(' + base + 'bb-plex-arabic-' + plexFor(parseInt(w[1], 10) || 400) + '.woff2) format("woff2")',
            { weight: w[1], style: w[2], unicodeRange: URANGE, display: 'swap' }));
        } catch (e) {}
      }
    }
    fillFaces();
    if (document.fonts && document.fonts.addEventListener) document.fonts.addEventListener('loading', fillFaces);

    // Carousels written for left to right. In Arabic the next item sits to the left, so the equipment gallery
    // (assets/bb-equipment.js) slides the other way, its arrow keys and swipes swap, the reviews arrows scroll
    // toward the left, and the B2B gallery swipe swaps. English pages never run this.
    function pressed(sel) { var b = document.querySelector(sel); if (b && !b.disabled) b.click(); }
    function carousels() {
      var track = document.getElementById('eq-gtrack');
      if (track) {
        var flip = function () {
          var t = track.style.transform;
          if (t && t.indexOf('translateX(-') === 0) track.style.transform = 'translateX(' + t.slice(12);
        };
        flip();
        new MutationObserver(flip).observe(track, { attributes: true, attributeFilter: ['style'] });
      }
      document.addEventListener('keydown', function (e) {
        if ((e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') || !e.target.closest || !e.target.closest('#eq-gstage')) return;
        e.stopPropagation();
        e.preventDefault();
        pressed(e.key === 'ArrowLeft' ? '#eq-gnext' : '#eq-gprev');
      }, true);
      var SWIPE = [['#eq-gtrack', '#eq-gnext', '#eq-gprev'], ['[data-b2b-stage]', '[data-b2b-next]', '[data-b2b-prev]']];
      var sx = 0, sw = null;
      document.addEventListener('touchstart', function (e) {
        sw = null;
        for (var i = 0; i < SWIPE.length; i++) {
          if (e.target.closest && e.target.closest(SWIPE[i][0])) { sw = SWIPE[i]; sx = e.touches[0].clientX; return; }
        }
      }, { capture: true, passive: true });
      document.addEventListener('touchend', function (e) {
        if (!sw) return;
        var s = sw, dx = e.changedTouches[0].clientX - sx;
        sw = null;
        e.stopPropagation();
        if (Math.abs(dx) > 40) pressed(dx > 0 ? s[1] : s[2]);
      }, { capture: true, passive: true });
      var rp = document.getElementById('eq-rprev'), rn = document.getElementById('eq-rnext');
      if (rp && rn) {
        var rail = function () { return document.querySelector('#rapid_reviews_items .r_items_list > ul'); };
        var state = function () {
          var t = rail();
          if (!t) return;
          var pos = Math.abs(t.scrollLeft), max = t.scrollWidth - t.clientWidth - 2;
          if (rp.disabled !== (pos <= 2)) rp.disabled = pos <= 2;
          if (rn.disabled !== (pos >= max)) rn.disabled = pos >= max;
        };
        document.addEventListener('click', function (e) {
          var b = e.target.closest && e.target.closest('#eq-rprev, #eq-rnext');
          var t = b && rail();
          if (!t) return;
          e.stopPropagation();
          var li = t.querySelector('li'), step = li ? li.getBoundingClientRect().width + 14 : 316;
          t.scrollBy({ left: b === rn ? -step : step, behavior: 'smooth' });
        }, true);
        new MutationObserver(state).observe(rp, { attributes: true, attributeFilter: ['disabled'] });
        new MutationObserver(state).observe(rn, { attributes: true, attributeFilter: ['disabled'] });
        document.addEventListener('scroll', function (e) { if (e.target === rail()) state(); }, true);
      }
    }

    // Arabic blocks, built from code points so the file stays plain ASCII.
    var AR = new RegExp('[' + [[0x600, 0x6ff], [0x750, 0x77f], [0x870, 0x8ff], [0xfb50, 0xfdff], [0xfe70, 0xfeff]].map(function (r) {
      return String.fromCharCode(r[0]) + '-' + String.fromCharCode(r[1]);
    }).join('') + ']');
    var LAT = /[A-Za-z]/;
    var SKIP = 'script,style,noscript,template,svg,input,textarea,select,[contenteditable],[dir=ltr]';

    function fix(el) {
      if (!el || el.__bbBidi || el === document.body || el === root) return;
      el.__bbBidi = 1;
      if (el.closest(SKIP)) return;
      var t = el.textContent;
      if (!t || AR.test(t) || !LAT.test(t)) return;
      var cs = getComputedStyle(el);
      el.style.unicodeBidi = 'plaintext';
      if (cs.display.indexOf('inline') === 0 && cs.display !== 'inline-block') return;
      var a = cs.textAlign;
      if (a === 'start' || a === 'right' || a === '-webkit-right') el.style.textAlign = 'right';
      else if (a === 'end' || a === 'left' || a === '-webkit-left') el.style.textAlign = 'left';
    }

    function scan(node) {
      if (!node) return;
      if (node.nodeType === 3) {
        if (LAT.test(node.nodeValue)) fix(node.parentElement);
        return;
      }
      if (node.nodeType !== 1) return;
      var w = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, null);
      var n;
      while ((n = w.nextNode())) if (LAT.test(n.nodeValue)) fix(n.parentElement);
    }

    var pending = [];
    var queued = false;
    function flush() {
      queued = false;
      var batch = pending;
      pending = [];
      for (var i = 0; i < batch.length; i++) scan(batch[i]);
    }

    function start() {
      try { carousels(); } catch (e) {}
      scan(document.body);
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var r = records[i];
          if (r.type === 'characterData') pending.push(r.target);
          for (var j = 0; j < r.addedNodes.length; j++) pending.push(r.addedNodes[j]);
        }
        if (pending.length && !queued) {
          queued = true;
          requestAnimationFrame(flush);
        }
      }).observe(document.body, { childList: true, subtree: true, characterData: true });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(start, 0); });
    else setTimeout(start, 0);
  } catch (e) {
    /* never block the page */
  }
})();